    document.addEventListener("DOMContentLoaded", function () {
      document.querySelectorAll(".upsellAtc").forEach((button) => {
        button.addEventListener("click", () => {
          const wrapper = button.closest(".upsell-product__wrapper");
          const variantId = wrapper.dataset.variantid;
          const qty = parseInt(wrapper.dataset.qty || "1", 10);
  
          button.disabled = true;
  
          addToCart(variantId, qty)
            .then(() => {
              button.disabled = false;
            })
            .catch((error) => {
              console.error("Fehler beim Hinzufügen zum Warenkorb:", error);
              button.disabled = false;
            });
        });
      });
  
      async function addToCart(variantId, qty) {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "xmlhttprequest",
          },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(variantId, 10),
                quantity: qty,
              },
            ],
          }),
        });
  
        if (!response.ok) {
          const text = await response.text();
          throw new Error(`Fehler ${response.status}: ${text}`);
        }
  
        const data = await response.json();
  
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent("product:added", {
          bubbles: true,
          detail: { quantity: qty }
        }));
  
        return data;
      }
    });